import React from 'react'
import { SetStudentSpecialCaseDialog, SecondaryCta } from 'components'

/**
 * Open dialog to set student as a special case
 * @param {object} params - The param object from the Mui DataGrid column definition
 * @returns {ReactComponentElement} - button component to open Special Cases dialog
 */
function GridSetStudentSpecialCaseAction({ row }) {
  return (
    <div className="flex flex-row-reverse flex-nowrap justify-between items-center gap-4 w-full">
      <SetStudentSpecialCaseDialog
        togglerComponent={SecondaryCta}
        togglerProps={{
          size: 'grid',
          className: 'min-w-[20em]',
        }}
        rowData={row}
      >
        Caso Especial
      </SetStudentSpecialCaseDialog>
    </div>
  )
}

export const MemoizedGridSetStudentSpecialCaseAction = React.memo(
  GridSetStudentSpecialCaseAction
)
